import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Eyebrow } from '../Eyebrow/Eyebrow';
import { Row } from '../server/layout/Row/index';
import { Stack } from '../server/layout/Stack/index';
import { Body } from '../server/typography/Body/index';
export function EyebrowField({ label, optional, tone, children, }) {
    return (_jsxs(Stack, { gap: "xs", children: [optional ? (_jsxs(Row, { gap: "sm", align: "baseline", children: [_jsx(Eyebrow, { tone: tone, children: label }), _jsx(Body, { size: "sm", color: "mute", as: "span", children: "optional" })] })) : (_jsx(Eyebrow, { tone: tone, children: label })), children] }));
}
//# sourceMappingURL=EyebrowField.js.map